module.exports = __webpack_public_path__ + "assets/train.bce8aff9.svg";